import { Action } from 'acscp/actions/action';

export class SetAcsOfficeBasedContacts extends Action {
    constructor(public telephoneNumber?: string,
                public mainSiteLink?: string) {
        super();
    }
}
